import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdmin } from '../../util/auth';
import { ROUTES } from '../../util/routes';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuth } = useAuth();
  const [authenticated, setAuthenticated] = useState(isAuth);

  useEffect(() => {
    setAuthenticated(isAuth);
  }, [isAuth]);

  if (!authenticated) return <Navigate to={ROUTES.LOGIN} />;
  if (adminOnly && !isAdmin()) return <Navigate to={ROUTES.HOME} />;

  // Support both layout route (no children → render Outlet) and wrapper pattern
  return children ?? <Outlet />;
};

export default ProtectedRoute;
